import Vue from 'vue';
import { Role } from 'shared/utils/constants';

import { AppState } from './app-state';

const defaultState: AppState = {
  form: {
    query: '',
    email: '',
    phone: '',
    target: 0,
    privacy: true,
    person_role: Role.Customer,
  },

  targets: {
    0: 'Для каких целей',
    1: 'Купля-продажа недвижимости',
    2: 'Аренда недвижимости',
    3: 'Для суда',
    4: 'Для банка',
    5: 'Для налоговой',
  },

  products: {
    list: [],
    byId: {},
    byName: {},
  },

  objectInfo: null,

  orderItems: null,

  step: 'form',
};

export const state: AppState = Vue.observable(defaultState);
